import { Branded } from 'types/generics/brand'

/**
 * The different metadata endpoints rolodex supports
 */
export enum RolodexMetadataField {
  Running_On = 'running_on',
  File_Backend = 'storage_backend',
  Version = 'version',
}

/** All Rolodex entries have a string "type" which implies their data schema */
export enum RolodexEntryType {
  // Main hierarchy
  ORGANIZATION = 'organization',
  SITE = 'site',
  SYSTEM = 'system',
  SITE_MODEL = 'site-model',
  UNIT = 'unit',
  COMPONENT = 'component',
  // Job-related
  JOB = 'job',
  INSPECTION = 'inspection',
  INSPECTION_FORM = 'inspection-form',
  REPORT = 'report',
  NDE = 'nde',
  // Visual inspection types
  VISUAL_INSPECTION = 'visual-inspection',
  VISUAL_INSPECTION_FORM = 'visual-inspection-form',
  VISUAL_INSPECTION_SECTION = 'visual-inspection-section',
  VISUAL_INSPECTION_FIELD = 'visual-inspection-field',
  VISUAL_INSPECTION_FORM_RESPONSE = 'visual-inspection-form-response',
  VISUAL_INSPECTION_SECTION_RESPONSE = 'visual-inspection-section-response',
  VISUAL_INSPECTION_FIELD_RESPONSE = 'visual-inspection-field-response',
  PHOTOGRAMMETRY_MODEL = 'photogrammetry-model',
  MATTERPORT_SPACE = 'matterport-space',
  GEOMETRIC_PIN = 'geometric-pin',
  // Component artifacts
  MARKUP_LAYER = 'markup-layer',
  COMPONENT_DEFAULTS = 'component-defaults',
  COMPONENT_DATA_FRAME = 'component-data-frame',
  COMPONENT_DATASET = 'component-dataset',
  ACTION_LOG = 'action-log',
  DUCK_DB_FEATURE_FLAG = 'forecast-duckdb-feature-flag',

  // INVENTORY
  EQUIPMENT = 'equipment',
  EQUIPMENT_CONFIGURATION = 'equipment-configuration',
  ASSEMBLY = 'assembly',
  ASSEMBLY_CONFIGURATION = 'assembly-configuration',
  WORK_ORDER = 'work-order',
  SUBTASK = 'subtask',
  SUB_ASSEMBLY = 'sub-assembly',

  // Process Flow Diagram
  PROCESS_FLOW_DIAGRAM = 'process-flow-diagram',
  CUSTOM_PFD_NODE = 'custom-pfd-node',

  // FDE types
  FDE_FORECAST_COMPONENT_CONFIG = 'forecast-component-config',
  ASSET_OUTAGE = 'asset-outage',
  FDE_UNIT = 'fde-customer-unit',
  REPAIR_PLAN = 'repair-plan',
  REPAIR_PLAN_CONFIG = 'repair-plan-config',
  REPAIR_SCENARIO = 'repair-scenario',
  REPLACEMENT_PLAN = 'replacement-plan',
  COMPONENT_HEALTH_PLAN = 'component-health-plan',
  COMPONENT_DEFICIENCY = 'component-deficiency',
  FDE_INSPECTION_METADATA = 'fde-inspection-metadata',
  FDE_COMPONENT_DATA_FRAME = 'fde-component-data-frame',
  DERATING_SCENARIO = 'fde-forecast-derating-scenario',
  COMPONENT_HEALTH_PLAN_ACTION = 'component-health-plan-action',
  INSPECTION_SCHEDULE_CONFIG_TYPE = 'fde-am-inspection-schedule-config',
  INSPECTION_OBJECT = 'fde-am-inspection',
  PIPE_WRAP = 'pipe-wrap',
  ASSET_MODEL = 'asset-model',
  THIRD_PARTY_INSPECTION_DETAILS = 'third-party-inspection-details',
  COMBINED_INSPECTION_METRICS = 'combined-inspection-metrics',
  UT_SCOPE_VALIDATION = 'ut-scope-validation',
  SITE_CONFIG = 'site-config',
  SITE_ASSET_HIERARCHY = 'site-asset-hierarchy',
  RISK_ASSESSMENT_CONFIG = 'risk-assessment-config',
  AS_PIPELINE_STATUS = 'as-pipeline-status',
  INDICATION = 'indication',
  INDICATION_SET = 'indication-set',
  LINE_AVERAGE_MARKUP_LAYER = 'line-average-ml',
  INSPECTION_REPORT_FORM = 'inspection-report-form',
  FORM_781A = 'form-781a',
  MICROSCOPE_REGION_OF_INTEREST = 'microscope-region-of-interest',
  UNIT_NII_METADATA = 'unit-nii-metadata',
  DRILLDOWN_EXPLORATION = 'drilldown-exploration',
  INDICATION_DAMAGE_AREA = 'indication-damage-area',
  KESTREL_MODEL = 'kestrel-model',
  KESTREL_MODEL_CAMERAS = 'kestrel-model-cameras',
  KESTREL_MODEL_UNIT = 'kestrel-model-unit',
  KESTREL_INSPECTION_METRICS = 'kestrel-inspection-metrics',
  RULER = 'ruler',
  FDE_AM_BATCH = 'fde-am-batch',
  COMPONENT_DATA_FRAME_CHUNKS = 'component-data-frame-chunks',
  FFS_CRITICAL_THICKNESS_PROFILE = 'ffs-critical-thickness-profile',
  FFS_LTA_REPORT = 'ffs-lta-report',
  ONTOLOGY = 'ontology',
  INDICATION_RECOMMENDATION = 'indication-recommendation',
  BUMBLEBEE_ASSET = 'bumblebee-asset',
  INDICATION_PHOTOGRAMMETRY = 'indication-photogrammetry',
  RIO_INDICATION_OVERVIEW = 'rio-indication-overview',
  ADVANCED_SERVICES_SCAN = 'advanced-services-scan',
  ROTATING = 'rotating',
  INDICATION_REPAIR_PLAN = 'indication-repair-plan',
  REPORTING_METADATA = 'reporting-metadata',
  WELD_CONFIG = 'weld-config',
  IMPORT_RAM = 'import-ram',
  ALERT = 'time-series-alert',

  // Salesforce
  SALESFORCE_ACCOUNT = 'sf-account',
  SALESFORCE_JOB = 'sf-job',
  SALESFORCE_RUG_COMPONENT_ASSIGNMENT = 'sf-rug-component-job-assignment',
  SALESFORCE_RUG_ASSET = 'sf-rug-asset',
  SALESFORCE_RUG_COMPONENT = 'sf-rug-component',
  SALESFORCE_RUG_SUBCOMPONENT = 'sf-rug-subcomponent',
  SALESFORCE_RUG_SUBCOMPONENT_ASSIGNMENT = 'sf-rug-subcomponent-job-assignment',
  SITE_CONFIG_TYPE = 'fde-asset-manager-site-config',
  EXTENSION_CONFIG = 'forecast-extension-config',
  // Point clouds
  POTREE_POINT_CLOUD = 'potree-point-cloud',
  POINT_CLOUD_SCENE = 'point-cloud-scene',
  OBSERVATION = 'observation',
  OBSERVATION_TICKET = 'observation-ticket',
  FORGING_INDICATION = 'forging-indication',
  MILL_PLAN = 'mill-plan',
  GEOGRAPHIC_PIN = 'geographic-pin',
  USER_COMMENT = 'user-comment',
  WALKDOWN = 'walkdown',
  WALKDOWN_REPORT_LINK = 'walkdown-report-link',
  WALKDOWN_UNIT_LINK = 'walkdown-unit-link',
  INSPECTION_ASSESSMENT = 'inspection-assessment',
  RISK_ASSESSMENT = 'risk-assessment',
  //Live Data Types
  DATA_POINTS = 'datapoints',
  MONITORING_LOCATION = 'monitoring-location',
  TIME_SERIES_DASHBOARD = 'time-series-dashboard',
  CHART = 'chart',
  TIME_SERIES_WORKBOOK = 'time-series-workbook',
  TIME_SERIES_DERIVED_VALUE = 'time-series-derived-value',
  // Asset Lens types
  ASSET_LENS_SENSOR_TAG = 'asset-lens-sensor-tag',
  ASSET_LENS_SENSOR_DATA = 'asset-lens-sensor-data',
  ASSET_LENS_WORK_ORDER = 'asset-lens-work-order',
  ASSET_LENS_IR_IMAGE = 'asset-lens-ir-image',
  ASSET_LENS_ACOUSTIC_IMAGE = 'asset-lens-acoustic-image',
  ASSET_LENS_MAINTENANCE_RECORD = 'asset-lens-maintenance-record',
  ASSET_LENS_ENVIRONMENTAL_DATA = 'asset-lens-environmental-data',
  ASSET_LENS_ANOMALY = 'asset-lens-anomaly',
  SYSTEM_DOCUMENT = 'system-document',
  ASSET_LENS_LOCATION = 'asset-lens-location',
  ASSET_LENS_EQUIPMENT = 'asset-lens-equipment',
  ASSET_LENS_INVENTORY_ITEM = 'asset-lens-inventory-item',
  ASSET_LENS_INVENTORY_STOCK = 'asset-lens-inventory-stock',
  VALUE_STORY = 'value-story',
  VALUE_STORY_TEMPLATE = 'value-story-template',
  SANDBOX = 'sandbox',
  // Navy Availbaility Planning types
  NAVY_REPAIR_PLAN = 'navy-repair-plan',
  NAVY_WORK_ORDER = 'navy-work-order',
  AVAIL_PLAN = 'availability-plan',
  ROOFTOP_FLIGHT_DATA = 'rooftop-flight-data',

  // NAES types
  KNOWLEDGE_DOCUMENT = 'knowledge-document',
  DETECTION_CONFIGURATION = 'detection-configuration',
  CASE = 'case',
  DOCUMENT_OCR = 'document-ocr',

  // Other
  USER_LIST = 'user-list',
  NAVBAR_CONFIG = 'navbar-config',
  NAVY_PRODUCTION_DASHBOARD_CONFIG = 'navy-production-dashboard-config',
  DOCUMENT_FIELDS = 'document-fields',
}

/**
 * Rolodex entries include a JSON blob of associated data, typically defined by
 * their type's schema.
 */
export type RolodexEntryDataType = Record<string, unknown>

/** Rolodex entries may be tagged to other Rolodex entries by their type names */
export type RolodexEntryTagsType = Partial<
  Record<RolodexEntryType, string | null>
>

/** Inspection entries in Rolodex have a special index for fast image lookup */
export type RolodexEntryIndexType = Record<string, string>

/**
 * A Rolodex entry consists of a unique string ID, a type, a JSON blob of
 * associated data, and tags to other Rolodex entries by their type names.
 */
export type RolodexEntryJson<
  TYPE_GENERIC extends RolodexEntryType = RolodexEntryType,
  DATA_GENERIC extends RolodexEntryDataType = RolodexEntryDataType,
> = {
  id: string
  type: TYPE_GENERIC
  data: DATA_GENERIC
  tags: RolodexEntryTagsType
  index: RolodexEntryIndexType
  generation: number
  updated_at: string
  created_at?: string
  created_by?: string
  last_updated_by?: string
  access_restriction: 'internal' | null
}

/**
 * The JSON required to perform a Rolodex "patch" operation (adding in new
 * data fields and/or tags)
 */
export type RolodexEntryPatchJson<
  Data extends RolodexEntryDataType = RolodexEntryDataType,
  Tags extends RolodexEntryTagsType = RolodexEntryTagsType,
> = {
  id: string
  type?: RolodexEntryType
  data?: Data
  delete_data?: string[]
  tags?: Tags
}

/**
 * The JSON required to perform a Rolodex "put" operation (upserting an entry)
 */
export type RolodexEntryPutJson<
  Data extends RolodexEntryDataType = RolodexEntryDataType,
  Tags extends RolodexEntryTagsType = RolodexEntryTagsType,
> = {
  id: string
  type: RolodexEntryType
  data: Data
  tags: Tags
  index?: RolodexEntryIndexType
  generation?: number
  updated_at?: string
}

/**
 * When loading entries from Rolodex any number of linked entries might be
 * returned for each entry in the main query result.
 */
export type RolodexLoadedEntryJson = {
  entry: RolodexEntryJson
  links?: Record<string, RolodexEntryJson>
}

/**
 * A globally unique ID for a Rolodex entry
 */
export type EntryID = Branded<string, 'EntryID'>
